(function patchAfterApp(){
  function applyGuards(Ctor){
    if (!Ctor || Ctor.__bbGuarded) return;
    const P = Ctor.prototype;
    const qs = (r,s)=>{ try{return r.querySelector(s);}catch(e){return null;} };

    const _connected = P.connectedCallback;
    P.connectedCallback = function(){ this.viewport = this.viewport || qs(this,'.theme-scroll--inner'); if (!this.viewport) return; try{ return _connected.apply(this, arguments);}catch(e){} };

    const _init = P.init;
    P.init = function(){ try{ this.setSlides && this.setSlides(); }catch(e){} if (!this.viewport || !this.slides || !this.slides.length) return; try{ return _init.apply(this, arguments);}catch(e){} };

    const _set = P.setListeners;
    P.setListeners = function(){
      try{
        this.nav = this.nav || qs(this,'.theme-scroll-nav');
        this.navPrev = this.navPrev || qs(this,'.flickity-prev');
        this.navNext = this.navNext || qs(this,'.flickity-next');
        if (this.nav) this.nav.addEventListener('click', this.onNavClick.bind(this));
        if (this.viewport){
          this.debouncedOnScroll = this.debouncedOnScroll || ((e)=>this.onScroll(e));
          this.viewport.addEventListener('scroll', this.debouncedOnScroll, {passive:true});
          this.viewport.addEventListener('resize', this.debouncedOnScroll);
        }
        if (this.resizeObserver && this.slides && this.slides[0]) this.resizeObserver.observe(this.slides[0]);
      }catch(e){}
      try{ return _set.apply(this, arguments);}catch(e){}
    };

    if (typeof P.onScroll === 'function') {
      const _s = P.onScroll; P.onScroll = function(){ if (!this.viewport) return; try{ return _s.apply(this, arguments);}catch(e){} };
    }
    if (typeof P.centerArrows === 'function') {
      const _c = P.centerArrows; P.centerArrows = function(){ if (!this.slides || !this.slides.length) return; try{ return _c.apply(this, arguments);}catch(e){} };
    }

    Ctor.__bbGuarded = true;
  }

  function tryPatch(){
    const C = customElements.get('theme-scroll');
    if (C) {
      applyGuards(C);
      // Re-run safe init for already-upgraded instances that failed
      document.querySelectorAll('theme-scroll').forEach(el=>{
        try {
          if (!el.viewport) { el.viewport = el.querySelector('.theme-scroll--inner'); }
          if (!el.viewport) return; // no hooks on this page
          if (typeof el.init === 'function') el.init();
        } catch(_){}
      });
      return true;
    }
    return false;
  }

  if (!tryPatch()) {
    // app.js may not have defined it yet — retry a few times
    let tries = 20, t = setInterval(()=>{ if (tryPatch() || --tries<=0) clearInterval(t); }, 100);
  }
})();